import React from "react";
import Chart from "react-apexcharts";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import {
  searchDepartureDates,
  searchDepartureDatesOriginal,
  setHotelPage,
  setOfferId,
} from "amadeusredux/lib/hotelSlice";
import { useSelector, useDispatch } from "react-redux";
import { setInbounddate, setOutbounddate } from "amadeusredux/lib/searchSlice";
import { search } from "amadeusredux/lib/api";
import { useIntl } from "react-intl";
import { printError } from "amadeusredux/lib/utils";

export default function OfferPriceChart(props) {
  const dispatch = useDispatch();

  const intl = useIntl();
  //console.log(intl.locale);
  const df = new Intl.DateTimeFormat(intl.locale, {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
  });
  const { offer } = props;
  const [startIndex, setStartIndex] = React.useState(-1);
  const holidayType = useSelector((state) => state.search.holidayType);

  const departureDates = useSelector((state) => state.hotel.departureDates);
  const departureDatesOriginal = useSelector(
    (state) => state.hotel.departureDatesOriginal
  );
  const departureOffers = departureDates.Offers?.Offer
    ? [...departureDates.Offers.Offer]
    : [];
  const departureOffersOriginal = departureDatesOriginal.Offers?.Offer
    ? [...departureDatesOriginal.Offers.Offer]
    : [];
  //console.log(departureDates);
  React.useEffect(() => {
    //console.log("d1");
    dispatch(searchDepartureDates()).then((data) => {
      //console.log(data);
      if (data.payload.error) {
        printError(data.payload.error);
        return;
      }
      //console.log("d2");
      dispatch(searchDepartureDatesOriginal());
    });
  }, [dispatch]);
  let chartCategories = [];
  let chartData = [];

  let chartDates = [];
  let chartDatesOriginal = [];

  let depdatename = "Abreisetag";
  if (holidayType.flight) {
    if (Array.isArray(departureOffers)) {
      departureOffers.sort((a, b) =>
        (holidayType.flight
          ? a.TravelDateInfo.DepartureDate
          : a.TravelDateInfo.CheckInDate
        ).localeCompare(
          holidayType.flight
            ? b.TravelDateInfo.DepartureDate
            : b.TravelDateInfo.CheckInDate
        )
      );
    }
    chartCategories = departureOffers.map(
      (e) => e.TravelDateInfo?.DepartureDate
    );
    chartDates = departureOffers.map((e) => e.TravelDateInfo?.DepartureDate);
    chartDatesOriginal = departureOffersOriginal.map(
      (e) => e.TravelDateInfo?.DepartureDate
    );
    if (offer) {
      chartData = departureOffers.map((e) =>
        e.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._
          ? Math.floor(
              e.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1
            )
          : e.PriceInfo?.Price?.value *
            (offer?.adults * 1 + offer?.children * 1)
      );
    } else {
      chartData = [];
    }
  } else {
    depdatename = "Anreisetag";
    if (Array.isArray(departureOffers)) {
      departureOffers.sort((a, b) =>
        (holidayType.flight
          ? a.TravelDateInfo.DepartureDate
          : a.TravelDateInfo.CheckInDate
        ).localeCompare(
          holidayType.flight
            ? b.TravelDateInfo.DepartureDate
            : b.TravelDateInfo.CheckInDate
        )
      );
    }
    chartCategories = departureOffers.map((e) => e.TravelDateInfo?.CheckInDate);
    chartDates = departureOffers.map((e) => e.TravelDateInfo?.CheckInDate);
    chartDatesOriginal = departureOffersOriginal.map(
      (e) => e.TravelDateInfo?.CheckInDate
    );
    if (offer) {
      chartData = departureOffers.map((e) =>
        e.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._
          ? Math.floor(
              e.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1
            )
          : e.PriceInfo?.Price?.value * (offer.adults * 1 + offer.children * 1)
      );
    } else {
      chartData = [];
    }
  }
  //  let minDate = "";
  let minValue = Number.MAX_SAFE_INTEGER;
  let idx = -1;
  if (offer) {
    for (let i = 0; i < departureOffersOriginal.length; i++) {
      if (
        minValue >
        departureOffersOriginal[i].PriceInfo?.Price?.value *
          (offer.adults * 1 + offer.children * 1)
      ) {
        idx = i;
        minValue =
          departureOffersOriginal[i].PriceInfo?.Price?.value *
          (offer.adults * 1 + offer.children * 1);
        //      minDate = departureOffers[i].TravelDateInfo?.DepartureDate;
      }
    }
  }

  if (offer) {
    for (let i = 0; i < departureOffers.length; i++) {
      if (
        minValue ===
          departureOffers[i].PriceInfo?.Price?.value *
            (offer.adults * 1 + offer.children * 1) &&
        departureOffersOriginal.find(
          (e) => e.OfferID === departureOffers[i].OfferID
        )
      ) {
        idx = i;
      }
    }
  }

  let maxValue = 0;

  if (offer) {
    for (let i = 0; i < departureOffersOriginal.length; i++) {
      if (
        maxValue <
        departureOffersOriginal[i].PriceInfo?.Price?.value *
          (offer.adults * 1 + offer.children * 1)
      ) {
        maxValue =
          departureOffersOriginal[i].PriceInfo?.Price?.value *
          (offer.adults * 1 + offer.children * 1);
        //      minDate = departureOffers[i].TravelDateInfo?.DepartureDate;
      }
    }
  }

  if (departureOffers.length > 11) {
    let si = -1;
    if (idx > startIndex + 5) si = idx - 2;
    if (si > departureOffers.length - 11) si = departureOffers.length - 11;
    if (si > -1 && startIndex === -1) setStartIndex(si);
    chartData = chartData.filter(
      (e, i) => i >= startIndex && i < chartData.length && i < startIndex + 11
    );
    chartDates = chartDates.filter(
      (e, i) => i >= startIndex && i < chartDates.length && i < startIndex + 11
    );

    chartCategories = chartCategories.filter(
      (e, i) =>
        i >= startIndex && i < chartCategories.length && i < startIndex + 11
    );
  }
  return (
    <div style={{ display: "Flex" }}>
      {startIndex > 0 && (
        <div
          onClick={() => {
            setStartIndex(startIndex - 1);
          }}
          style={{ paddingTop: 70 }}
        >
          <FaChevronLeft />
        </div>
      )}
      {offer && (
        <div style={{ flexGrow: 1 }}>
          <div className="chartheadline">
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (
                  idx > departureOffers.length - 11 &&
                  departureOffers.length > 11
                )
                  idx = departureOffers.length - 11;
                setStartIndex(idx > 1 ? idx - 2 : idx);
              }}
            >
              Günstigster Preis
            </span>{" "}
            pro {depdatename}
          </div>
          <Chart
            options={{
              tooltip: {
                enabled: false,
              },
              chart: {
                toolbar: { show: false },
                height: 150,

                type: "bar",
                events: {
                  dataPointSelection: function (event, chartContext, config) {
                    /*console.log("*************************", config, chartContext, event);
                    console.log(config.w.config);
                    console.log(config.w);
                    console.log(config.w.config.xaxis.categories[config.dataPointIndex])
                    console.log(config);
                    console.log(config.w.config.series[config.seriesIndex])
                    console.log(config.w.config.series[config.seriesIndex].name)
                    console.log(config.w.config.series[config.seriesIndex].data[config.dataPointIndex])
                    console.log(config.config.series);*/
                    if (config.dataPointIndex < 0) {
                    } else {
                      dispatch(setHotelPage(1));
                      dispatch(
                        setOfferId(
                          departureOffers[config.dataPointIndex + startIndex]
                            .OfferID
                        )
                      );
                      //console.log(departureOffers[config.dataPointIndex]);

                      dispatch(
                        setOutbounddate(
                          departureOffers[config.dataPointIndex + startIndex]
                            .TravelDateInfo.DepartureDate
                            ? departureOffers[
                                config.dataPointIndex + startIndex
                              ].TravelDateInfo.DepartureDate
                            : departureOffers[
                                config.dataPointIndex + startIndex
                              ].TravelDateInfo.CheckInDate
                        )
                      );

                      console.log(chartDates[config.dataPointIndex]);
                      console.log(
                        departureOffers[config.dataPointIndex + startIndex]
                          .TravelDateInfo
                      );
                      console.log(
                        departureOffers[config.dataPointIndex + startIndex]
                          .TravelDateInfo.ReturnDate
                          ? departureOffers[config.dataPointIndex + startIndex]
                              .TravelDateInfo.ReturnDate
                          : departureOffers[config.dataPointIndex + startIndex]
                              .TravelDateInfo.CheckOutDate
                      );

                      dispatch(
                        setInbounddate(
                          departureOffers[config.dataPointIndex + startIndex]
                            .TravelDateInfo.ReturnDate
                            ? departureOffers[
                                config.dataPointIndex + startIndex
                              ].TravelDateInfo.ReturnDate
                            : departureOffers[
                                config.dataPointIndex + startIndex
                              ].TravelDateInfo.CheckOutDate
                        )
                      );
                      search(dispatch, true, false, 0, true);
                      //window.scrollTo(0, 0);
                    }
                  },
                },
              },

              plotOptions: {
                bar: {
                  columnWidth: "50%",
                },
              },
              dataLabels: {
                enabled: true,
              },
              stroke: {
                width: 1,
              },

              grid: {
                row: {
                  colors: ["#fff", "#f2f2f2"],
                },
              },
              xaxis: {
                labels: {
                  formatter: function (value) {
                    return value
                      ? df.format(new Date(value)).split(",")
                      : value;
                  },
                  rotate: 0,
                },
                categories: chartCategories,
                tickPlacement: "on",
              },
              yaxis: {
                title: {
                  text: "",
                },
                labels: {
                  formatter: function (value) {
                    return "";
                  },
                },
              },
              colors: [
                function ({ value, seriesIndex, w, dataPointIndex }) {
                  if (!chartDatesOriginal.includes(chartDates[dataPointIndex]))
                    return "#999999";
                  if (value === minValue) {
                    return "#59c246";
                  } else if (value === maxValue) {
                    return "#d31e27";
                  } else {
                    return "#007aff";
                  }
                },
              ],
            }}
            series={[
              {
                name: "Preise",
                data: chartData,
              },
            ]}
            type="bar"
            height={200}
          />
        </div>
      )}
      {startIndex < departureOffers.length - 11 && (
        <div
          onClick={() => setStartIndex(startIndex + 1)}
          style={{ paddingTop: 70 }}
        >
          <FaChevronRight />
        </div>
      )}
    </div>
  );
}
